module.exports = __webpack_public_path__ + "static/banner-image-eaa87bdda8c22023a3e93cef9426c26a.png";